import React from 'react';
import GenericShipmentRequest from '../GenericShipmentRequest';

const AdminSectionShipmentRequest = () => (
  <GenericShipmentRequest
    sectionName="Admin Section"
    sectionKey="Admin Section"
    backRoute="/sections/admin-section"
  />
);

export default AdminSectionShipmentRequest;
